import "./home.css";
import { useState } from "react";
import Header from "../../components/Header";

import SideBar from "../../components/SideBar";
import { SuccesToast } from "../../components/Toast/message";
import { useNavigate } from "react-router-dom";
import { RiMoneyDollarCircleFill, } from "react-icons/ri";
//
const Home = () => {
  const navigate = useNavigate()

  return (
    <div className="main">
      <div id="Sportbook">
        <div className="container bg-color-sportbook custom-card4">
          <div className="inner-space1">
            <div className="row">
              <div className="col-md-12">
                <h2 className="mb-4">Control Panel BettGaming</h2>
                <p className="custom-card4p">
                  Select the features in the menu above
                </p>
              </div>
            </div>
            <div className="row" style={{ backgroundColor: '#fff', padding: '5px 0px 20px 0px' }}>
              <div className="col-md-8 mx-auto">
                <div className="row">

                <div className="col-md-3" onClick={() => navigate("/UserList")}>
                    <div className="card-box">
                    <img width={'64px'} src="/images/icons/uaers.png" />
                      <h4>Users</h4>
                    </div>
                  </div>
                  <div className="col-md-3" onClick={() => navigate("/Transfer")}>
                    <div className="card-box">
                      {/* <RiMoneyDollarCircleFill size={40} /> */}
                      <img src="/images/icons/Box_recycle.png" />
                      <h4>Transfer</h4>
                    </div>
                  </div>
                  <div className="col-md-3" onClick={() => navigate("/Bets")}>
                    <div className="card-box" >
                      <img src="/images/icons/Book_phones.png" />
                      <h4>Multiline Bets                        
                        </h4>
                    </div>
                  </div>

                  <div className="col-md-3" onClick={() => navigate("/config-list")} >
                    <div className="card-box">
                      <img src="/images/icons/Clipboard_3.png" />
                      <h4>configuration</h4>
                    </div>
                  </div> 

                  <div className="col-md-3" onClick={() => navigate("/player-bonus")} >
                    <div className="card-box">
                      <img src="/images/icons/Clipboard_3.png" />
                      <h4>Player Type<br/> bonus config</h4>
                    </div>
                  </div> 

                  
                  <div className="col-md-3" onClick={() => navigate("/wheel-of-fortune")}>
                    <div className="card-box">
                      <img src="/images/icons/Clipboard_3.png" />
                      <h4>WOF Configuration</h4>
                    </div>
                  </div>
                  
                  {/* <div className="col-md-3" onClick={() => navigate("/Results")} >
                    <div className="card-box">
                      <img src="/images/icons/Clipboard_3.png" />
                      <h4>Results</h4>
                    </div>
                  </div> */}

                  <div className="col-md-3" onClick={() => navigate("/pools")} >
                    <div className="card-box">
                      <img  width={'64px'} src="/images/icons/betlogo.png" />
                      <h4>Bet v/s player<br/>
                        Pools
                      </h4>
                    </div>
                  </div>

                  <div className="col-md-3" onClick={() => navigate("/bet-results")} >
                    <div className="card-box">
                      <img  width={'64px'} src="/images/icons/betlogo.png" />
                      <h4>Bet v/s player<br/>
                        Bets
                      </h4>
                    </div>
                  </div>

                <div className="col-md-3" onClick={() => navigate("/kyc-list")} >
                    <div className="card-box">
                      <img  width={'64px'} src="/images/icons/Clipboard_3.png" />
                     <h4>KYC List</h4>
                    </div>
                  </div> 
                 
     
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Home;
